import { useState } from 'react';

interface RunbookFeedbackProps {
  onThumbsUp: () => void;
  onThumbsDown: () => void;
}

export function RunbookFeedback({ onThumbsUp, onThumbsDown }: RunbookFeedbackProps) {
  const [submitted, setSubmitted] = useState(false);

  if (submitted) {
    return (
      <div className='border-t border-gray-200 pt-3'>
        <span className='text-sm text-green-600'>Thank you for your feedback!</span>
      </div>
    );
  }

  return (
    <div className='flex items-center gap-2 border-t border-gray-200 pt-3'>
      <span className='text-sm text-gray-500'>Was this helpful?</span>
      <button
        onClick={() => {
          onThumbsUp();
          setSubmitted(true);
        }}
        className='rounded-md border border-gray-300 px-3 py-1 text-sm transition-colors hover:border-green-300 hover:bg-green-50'
        aria-label='Thumbs up'
      >
        Yes
      </button>
      <button
        onClick={onThumbsDown}
        className='rounded-md border border-gray-300 px-3 py-1 text-sm transition-colors hover:border-red-300 hover:bg-red-50'
        aria-label='Thumbs down'
      >
        No, wrong runbook
      </button>
    </div>
  );
}
